(() => {
  if (customElements.get('ac-user-guides')) return;
  customElements.define('ac-user-guides', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.tabs = Array.from(this.querySelectorAll('[data-guide-model]'));
      this.panels = Array.from(this.querySelectorAll('[data-guide-panel]'));
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-guide-model]');
        if (tab && this.contains(tab)) this.select(tab.dataset.guideModel, true);
        const play = event.target.closest('[data-guide-play]');
        if (play && this.contains(play)) this.play(play);
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.select(this.tabs[next].dataset.guideModel, true);
        this.tabs[next].focus();
      }, options);
      this.syncLocation = () => {
        const url = new URL(location.href);
        let model = url.searchParams.get('model') || url.hash.slice(1);
        if (!model && document.referrer) {
          try {
            const previous = new URL(document.referrer);
            if (previous.origin === location.origin && previous.pathname.includes('/products/acemate-tennis-robot-s10-pro')) model = 's10-pro';
          } catch {}
        }
        this.select(this.tabs.some(tab => tab.dataset.guideModel === model) ? model : this.tabs[0]?.dataset.guideModel, false);
      };
      window.addEventListener('popstate', this.syncLocation, options);
      window.addEventListener('hashchange', this.syncLocation, options);
      this.syncLocation();
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-guide-panel]');
        if (panel && this.contains(panel)) this.select(panel.dataset.guidePanel, false);
      }, options);
    }
    stop(panel) {
      panel.querySelectorAll('[data-guide-player] iframe').forEach(frame => frame.remove());
      panel.querySelectorAll('[data-guide-play]').forEach(button => {button.hidden = false;});
    }
    select(model, updateUrl) {
      if (!this.tabs.some(tab => tab.dataset.guideModel === model)) return;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.guideModel === model;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const selected = panel.dataset.guidePanel === model;
        if (!selected) this.stop(panel);
        panel.hidden = !selected;
      });
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('model', model);
        history.replaceState(history.state, '', url);
      }
    }
    play(button) {
      const player = button.closest('[data-guide-player]');
      const template = player?.querySelector('template[data-guide-video-template]');
      if (!template || player.querySelector('iframe')) return;
      const frame = template.content.firstElementChild.cloneNode(true);
      player.appendChild(frame);
      button.hidden = true;
      frame.focus();
    }
    disconnectedCallback() {
      this.panels?.forEach(panel => this.stop(panel));
      this.abort?.abort();
      this.abort = null;
    }
  });
})();
